// ----------------------------------------------------------------------

export const PATH = {
  website: 'https://sowan.sa/',
  root: '/',
  overview: '/overview',
  subscription: {
    business: {
      root: '/business',
      view: '/business/',
    },
  },
  distributor: {
    distributor: {
      root: '/distributor/distributor',
      view: '/distributor/distributor/',
    },
    commission: '/distributor/commission',
  },
  project: {
    root: '/project/board',
  },
  explore: {
    overview: '/explore/overview',
    record: {
      root: '/explore/record',
      view: '/explore/record/',
    },
    report: '/explore/report',
  },
  support: {
    root: '/support',
    view: '/support/',
    settings: '/support/settings',
  },
  management: {
    settings: {
      root: '/management/settings',
      general: '/management/settings?tab=general',
      profile: '/management/settings?tab=profile',
      change_password: '/management/settings?tab=change_password',
    },
    user: {
      root: '/management/user',
      view: '/management/user/',
    },
    role: {
      root: '/management/role',
      view: '/management/role/',
    },
    tax: {
      root: '/management/tax',
      view: '/management/tax/',
    },
    plan: {
      root: '/management/plan',
      view: '/management/plan/',
    },
    discount: {
      root: '/management/discount',
      view: '/management/discount/',
    },
    categoryExpense: {
      root: '/management/category-expense',
      view: '/management/category-expense/',
    },
    uom: {
      root: '/management/uom',
      view: '/management/uom/',
    },
    nearpayTerminal: {
      root: '/management/nearpay-terminal',
      view: '/management/nearpay-terminal/',
    },
  },
  auth: {
    login: '/login',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password/',
  },
  misc: {
    suspend: '/suspend',
    page403: '/403',
    page404: '/404',
  },
};
